import styled, { keyframes } from 'styled-components';

export const FieldWrapper = styled.div`
    margin: 15px;
    @media screen and (max-width: 768px) {
        margin: 20px 5px;
    }
`;


const slideAnimation = keyframes`
    0 {
        left: 0;
        opacity:0;
        width: 0;
    }
    100% {
        left: -250px;
        opacity:1;
    }
`;

export const SlideMenu = styled.div`
    z-index: 11;
    position: absolute;
    width: 250px;
    left: 0;
    height: 100%;
    color: '#44444';
    overflow: auto;
    border: ${props => props.bordered ? '10px solid white' : null};
    background: ${props => props.filled ? '#e2e2e4' : 'none'};
    animation: ${slideAnimation};
    opacity: 0;
    animation-duration: 0.1s;
    animation-timing-function:cubic-bezier(.46,.46,.28,1);
    animation-fill-mode: forwards;
    
    &::-webkit-scrollbar {
        display: none;
    }
`;

